const isCancellationError = error =>
	error?.name === 'AbortError' ||
	error?.name === 'CanceledError' ||
	error?.code === 'ERR_CANCELED' ||
	error?.__CANCEL__ === true;

export const createNewPackageOptionsLoader = ({
	getArticles,
	getItemStates,
	getZonesAreas,
	formatRows,
}) => {
	const controller = new AbortController();
	let isActive = true;

	const load = ({ onSuccess, onError }) =>
		Promise.all([
			getArticles(controller.signal),
			getItemStates(controller.signal),
			getZonesAreas(controller.signal),
		])
			.then(([articles = [], stateArticles = [], zonesAreas = {}]) => {
				if (!isActive || controller.signal.aborted) return;

				onSuccess({
					articles: formatRows(articles.filter(item => item.is_serialized)),
					stateArticles: formatRows(stateArticles),
					zones: formatRows(zonesAreas.zones || []),
					areas: formatRows(zonesAreas.areas || []),
				});
			})
			.catch(error => {
				if (
					!isActive ||
					controller.signal.aborted ||
					isCancellationError(error)
				)
					return;

				onError(error);
			});

	const cancel = () => {
		isActive = false;
		controller.abort();
	};

	return {
		signal: controller.signal,
		load,
		cancel,
	};
};
